import React from "react";

// Chakra imports
import { Box, Flex, Icon, Select, Text, useColorModeValue } from "@chakra-ui/react";
import BarChart from "components/charts/BarChart";

// Custom components
import Card from "components/card/Card.js";
import {
  barChartDataDailyTraffic,
  barChartOptionsDailyTraffic,
} from "variables/charts";

// Assets
import { RiArrowUpSFill } from "react-icons/ri";

export default function DailyTraffic(props) {
  const { 
    successRate = 0, 
    dailyData = [], 
    timeFilter = 'last-week',
    onTimeFilterChange = () => {},
    ...rest 
  } = props;

  // Chakra Color Mode
  const textColor = useColorModeValue("secondaryGray.900", "white");
  
  // Debug what data we're receiving
  console.log('📊 DailyTraffic received data:', { 
    successRate, 
    dailyDataLength: dailyData.length, 
    dailyData: dailyData.slice(0, 3),
    timeFilter
  });

  // Create chart data from real data - NO fallback to mock data
  const chartData = [
    {
      name: "Success Rate",
      data: dailyData.length > 0 ? dailyData.map(d => d.successRate) : [0], // Show 0 if no data
    },
  ];
  
  const chartOptions = {
    ...barChartOptionsDailyTraffic,
    xaxis: {
      ...barChartOptionsDailyTraffic.xaxis,
      categories: dailyData.length > 0 ? dailyData.map(d => d.label) : ["No Data"], // Show "No Data" if empty
    }
  };
  
  return (
    <Card align='center' direction='column' w='100%' {...rest}>
      <Flex justify='space-between' align='start' px='10px' pt='5px'>
        <Flex flexDirection='column' align='start' me='20px'>
          <Flex w='100%' justify='space-between' align='center'>
            <Text
              color='secondaryGray.600'
              fontSize='sm'
              fontWeight='500'>
              Success Rate
            </Text>
            <Select
              value={timeFilter}
              onChange={(e) => onTimeFilterChange(e.target.value)}
              size='sm'
              fontSize='xs'
              fontWeight='500'
              borderRadius='5px'
              border='1px solid'
              borderColor='secondaryGray.300'
              w='auto'
              minW='100px'>
              <option value='today'>Today</option>
              <option value='last-week'>Week</option>
              <option value='last-month'>Month</option>
              <option value='last-3-months'>3 Months</option>
            </Select>
          </Flex>
          <Flex align='end'>
            <Text
              color={textColor}
              fontSize='34px'
              fontWeight='700'
              lineHeight='100%'>
              {successRate.toFixed(1)}%
            </Text>
            <Text
              ms='6px'
              color='secondaryGray.600'
              fontSize='sm'
              fontWeight='500'>
              Average
            </Text>
          </Flex>
        </Flex>
        <Flex align='center'>
          <Icon as={RiArrowUpSFill} color='green.500' />
          <Text color='green.500' fontSize='sm' fontWeight='700'>
            +4.8%
          </Text>
        </Flex>
      </Flex>
      <Box h='240px' mt='auto'>
        <BarChart
          chartData={chartData}
          chartOptions={chartOptions}
        />
      </Box>
    </Card>
  );
}
